export default __webpack_public_path__ + "static/TeamMartin-7cb8830fb8d275785e5fb399e6bd237d.png";